import { MouseEvent, ReactNode } from 'react';
import { Link as LinkRouter, LinkProps } from 'react-router-dom';
import { useDependencies } from '../dependencies';

interface Props extends LinkProps {
  newTab?: boolean;
  children?: ReactNode;
  external?: boolean;
  externalUS?: boolean;
}

const Link = (props: Props): JSX.Element => {
  const { children, to, newTab, external, externalUS, onClick, ...rest } = props;

  const {
    services: { tracker },
  } = useDependencies();

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>): Promise<void> => {
    const element = e.target as HTMLElement;

    const trackingProps = {
      elementText: element.innerText,
      elementId: element.id,
    };

    await tracker.track('clicked-button', trackingProps);

    if (onClick) {
      onClick(e);
    }
  };

  const target = newTab ? '_blank' : undefined;
  const rel = external && !externalUS ? 'noopener noreferrer' : undefined;
  return external || externalUS ? (
    // order matters
    <a {...rest} target={target} rel={rel} href={to.toString()} onClick={handleClick}>
      {children}
    </a>
  ) : (
    // order matters
    <LinkRouter {...rest} target={target} rel={rel} to={to} onClick={handleClick}>
      {children}
    </LinkRouter>
  );
};

export { Link };
